import Vue from "vue";
import BlogPostsList from "./components/BlogPostsList.vue";

Vue.config.productionTip = false;
Vue.prototype.uiVersion = window.uiVersion;
new Vue({
  render: (h) => h(BlogPostsList)
}).$mount("#blog-posts");
